"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _colors = require("HubStyleTokens/colors");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  margin-bottom: 20px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HubSubtitle = _styledComponents.default.div.withConfig({
  displayName: "HubSubtitle",
  componentId: "sc-54n1iz-0"
})(_templateObject(), _colors.OBSIDIAN);

var _default = HubSubtitle;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/common/HubSubtitle.js
// module id = 256
// module chunks = 5 6